import { Button, ButtonProps } from '@mis/sushi-tailwind-react';
import classNames from 'classnames';
import React from 'react';

export const MiddleDarkButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      type="button"
      data-testid="btnMiddleDark"
      {...props}
      className={classNames('bg-linear-to-t to-[#646568] from-[#97989B] text-white', props.className)}
    />
  );
};
